import React, { useEffect, useState } from "react";
import {Modal, Button} from 'react-bootstrap';
import APICom from "../../utils/helpers/APICom";
import {  useSelector } from "react-redux";
import ConfirmationModal from '../Controls/ConfirmationModal';

const DispatchAction = (props) => {
    /*
    Props Properties:
    DispatchDriverData
    DispatchVehicleData

    */
    const { ASCSSettingData } = useSelector((store) => store.combinedata);
    const [showDispatchAlert, setShowDispatchAlert] = useState(false);
    const [DispatchAlert, setDispatchAlert] = useState({alertTitle : '', alertMsg: ''});
    const { loginData } = useSelector((store) => store.login);
    const [confirmationModalObj, setConfirmationModalObj] = useState({show: false, title:'Dispatch Action', body:'', btnCanceText: 'Ok', btnOkText: 'Cancel', 'ConfirmationSuccessFunctionName': ''});
    const [DispatchMethod, setDispatchMethod] = useState(2);

    const [vForceDispatchMultiTip, setvForceDispatchMultiTip] = useState("");
    const [vConfirmDeviceDispatched, setvConfirmDeviceDispatched] = useState("");
    const [vInCaseOfNotAvailableDevContManual, setvInCaseOfNotAvailableDevContManual] = useState("");

    useEffect(() => {
        const Main = async () => {
            if(props.GridRowData === null || props.GridRowData.length <= 0)
            {
                setDispatchAlert({...DispatchAlert, alertTitle: 'No trip selected', alertMsg:'Please select a trip to Dispatch.'});
                setShowDispatchAlert(true);
                return;
            }
            let iAffID = -1;
            let Vehicle = "", Driver = "";
            
            iAffID = props.GridRowData[0].iSRATSPID;
            try {
                setDispatchMethod(parseInt(JSON.parse(ASCSSettingData[parseInt(iAffID)]).filter(function(item) { return item["SubTitle"] === "DispatchMethod"; })[0].value));
            }
            catch(error) { }

            Vehicle = props.selectedVehicle;
            Driver = props.selectedDriver;
            if (Vehicle != "" && parseInt(Vehicle) <= 0 && (DispatchMethod == 0 || DispatchMethod == 2)) {
                setDispatchAlert({...DispatchAlert, alertTitle: 'Vehicle not selected', alertMsg:'Vehicle not selected. Please select Vehicle to Dispatch.'});
                setShowDispatchAlert(true);
                return;
            }
            if (Driver != "" && parseInt(Driver) <= 0 && (DispatchMethod == 1 || DispatchMethod == 2)) {
                setDispatchAlert({...DispatchAlert, alertTitle: 'Driver not selected', alertMsg:'Driver not selected. Please select Driver to Dispatch.'});
                setShowDispatchAlert(true);
                return;
            }
            if(typeof iAffID === "string"){
                iAffID = parseInt(iAffID);
            }
            
            let SelectedAffiliateVehicleData = [];
            let SelectedAffiliateDriversData = [];

            if(props.DispatchVehicleData !== undefined && props.DispatchVehicleData !== null){
                let DispatchVehiclesByAffiliate = props.DispatchVehicleData[iAffID];
                if(DispatchVehiclesByAffiliate !== "" && DispatchVehiclesByAffiliate !== undefined && DispatchVehiclesByAffiliate !== null){
                    SelectedAffiliateVehicleData = JSON.parse(DispatchVehiclesByAffiliate);
                }
            }
            if(props.DispatchDriverData !== ""  && props.DispatchDriverData !== undefined && props.DispatchDriverData !== null){
                let DispatchDriversByAffiliate = props.DispatchDriverData[iAffID];
                if(DispatchDriversByAffiliate !== ""){
                    SelectedAffiliateDriversData = JSON.parse(DispatchDriversByAffiliate);
                }
            }



            let GridRows = props.GridRowData;

            const ManifestRecords = GridRows.filter(function (rw) {
                return rw["vManifestNumber"] != "";
            });
            let MaxChairsData = {"MaxAmbulatory": "0","MaxWC": "0"}
            if(ManifestRecords.length > 0) {
                MaxChairsData = await LoadRoutInfoByManifest(ManifestRecords[0]["vManifestNumber"]);
                
                //Check for Vehicle Capacity.
                let _isVehWheelChair = SelectedAffiliateVehicleData.filter(function(item){
                    return parseInt(MaxChairsData.MaxWC) > parseInt(item.MaxWheelChairs) && item.VehicleID.toString() == Vehicle;
                });
                let _isVehAmbulatory = SelectedAffiliateVehicleData.filter(function (item) {
                    return item.VehicleID == Vehicle;
                });
                let _maxAmbulatory = (parseInt(_isVehAmbulatory.TotalCapacity) - Math.ceil(parseFloat(_isVehAmbulatory.MaxWheelChairs) * parseFloat(_isVehAmbulatory.LessPerWheelChair)));
                if (_isVehWheelChair.length > 0 || parseInt(MaxChairsData.MaxAmbulatory) > _maxAmbulatory) {
                    var Msg = "";
                    if (_isVehWheelChair.length > 0) {
                        Msg = "Vehicle capacity does not match with the route max WheelChair capacity, do you still want to continue ?"
                    } else if (parseInt(MaxChairsData.MaxAmbulatory) > _maxAmbulatory) {
                        Msg = "Vehicle capacity does not match with the route max Ambulatory capacity, do you still want to continue ?"
                    }
                    if(Msg !== "") {
                        setConfirmationModalObj({show: true, title:'Confirm dispatch', body:Msg, btnCanceText: 'No', btnOkText: 'Yes', ConfirmationSuccessFunctionName: 'checkForWheelChairDispatch'});
                    }
                    else{
                        checkForWheelChairDispatch();
                    }
                }
                else{
                    checkForWheelChairDispatch();
                }
            }
            else{
                checkForWheelChairDispatch();
            }

            return;

        }
        Main();
        return () => {
            // Perform cleanup operations if needed
        };
    }, []);


    async function LoadRoutInfoByManifest(ManifestNumber){
        try{
                let requestObj = {
                    "manifestnumber": ManifestNumber
                }
                let response = await APICom.fetchData("", "TripActions/GetRouteManagement", "post", { "Content-Type": "application/json" }, requestObj, null);
                let result = response.data;
                return result[0];
            }
        catch (e) {}
        return {
            "MaxAmbulatory": "0",
            "MaxWC": "0"
        };
    }

    async function checkForWheelChairDispatch() {
        DeviceDispatch();
    }


    async function DeviceDispatch() {
        let ServiceIDs = "", vRequestSourceList = "", vSchDetailIDs = "", pvManifestNumber = "";;
        props.GridRowData.forEach(function (itm) {
            ServiceIDs = ServiceIDs + "," + itm.ServiceID;
            vRequestSourceList = vRequestSourceList + "," + itm.TableSource;
            vSchDetailIDs = vSchDetailIDs + "," + itm.SchDetailID;
            if (pvManifestNumber.indexOf(itm["vManifestNumber"]) < 0){
                pvManifestNumber = pvManifestNumber + "," + itm["vManifestNumber"];
            }
        });
        try{
            ServiceIDs = ServiceIDs.substring(1);
        }
        catch(err){}
        try{
            vRequestSourceList = vRequestSourceList.substring(1);
        }
        catch(err){}
        try{
            vSchDetailIDs = vSchDetailIDs.substring(1);
        }
        catch(err){}
        pvManifestNumber = pvManifestNumber.replace(/^,*(.*?),*$/, '$1');
        if(pvManifestNumber != ""){
            let requestObj = {
                "ManifestIDsList": pvManifestNumber,
                "VehicleID":props.selectedVehicle,
                "DriverID":props.selectedDriver,
                "iModifiedByUID":loginData.iUserID,
                "iModifiedByAppID":"26",
                "bOnlyPreferedVehicle":props.chkVehicleRequiredRef.toString()
            }
            let response = await APICom.fetchData("", "TripActions/ManifestDeviceDispatch", "post", { "Content-Type": "application/json" }, requestObj, null);
            let bSuccess = false;
            try{
                let result = response.data[0];
                if(result["Action"] == "True"){
                    bSuccess = true;
                    // handleDispatchAlertModalClose();
                    setDispatchAlert({...DispatchAlert, alertTitle: 'Dispatch Successful', alertMsg:'Manifest(s) dispatched successfully.'});
                    setShowDispatchAlert(true);
                    
                }
            }
            catch (e) { }
            if(bSuccess === false){
                alert("Manifest dispatch failed. Please check trip selection and try again.");
                UnMountDispatchActionCompoennt();
            }
        }
        else{
            let requestObj = {
                "vServiceIDs": ServiceIDs,
                "vRequestSourceList":vRequestSourceList,
                "iAssignedVehicleId":props.selectedVehicle,
                "iAssignedDriverId":props.selectedDriver,
                "iModifiedByUID":loginData.iUserID,
                "iModifiedByAppID":"26",
                "bRedispatch":"false",
                "bValidateMandatoryAttr":"false",
                "vForceDispatchMultiTip":vForceDispatchMultiTip,
                "vConfirmDeviceDispatched":vConfirmDeviceDispatched,
                "vInCaseOfNotAvailableDevContManual":vInCaseOfNotAvailableDevContManual,
                "vSchDetailIDs":vSchDetailIDs,
                "bOnlyPreferedVehicle":props.chkVehicleRequiredRef.toString()
            }
            let response = await APICom.fetchData("", "TripActions/DeviceDispatch", "post", { "Content-Type": "application/json" }, requestObj, null);
            let result = response.data;
            if(result["vErrorOutput"] != ""){
                alert(result["vErrorOutput"]);
                UnMountDispatchActionCompoennt();
            }
            else if(result["vForceDispatchMultiTip"] != ""){
                setvForceDispatchMultiTip("True");
                setConfirmationModalObj({show: true, title:'Confirm dispatch', body:result["vForceDispatchMultiTip"], btnCanceText: 'No', btnOkText: 'Yes', ConfirmationSuccessFunctionName: 'DeviceDispatch'});
            }
            else if(result["vConfirmDeviceDispatched"] != ""){
                setvConfirmDeviceDispatched("True");
                setConfirmationModalObj({show: true, title:'Confirm dispatch', body:result["vConfirmDeviceDispatched"], btnCanceText: 'No', btnOkText: 'Yes', ConfirmationSuccessFunctionName: 'DeviceDispatch'});
            }
            else if(result["vInCaseOfNotAvailableDevContManual"] != ""){
                setvInCaseOfNotAvailableDevContManual("True");
                setConfirmationModalObj({show: true, title:'Confirm dispatch', body:result["vInCaseOfNotAvailableDevContManual"], btnCanceText: 'No', btnOkText: 'Yes', ConfirmationSuccessFunctionName: 'DeviceDispatch'});
            }
            else{
                setDispatchAlert({...DispatchAlert, alertTitle: 'Dispatch Successful', alertMsg:'Trip(s) dispatched successfully.'});
                setShowDispatchAlert(true);
                UnMountDispatchActionCompoennt();
            }
        }
    }

    const handleDispatchAlertModalClose = () => {
        setShowDispatchAlert(false);
        UnMountDispatchActionCompoennt();
    }

    const UnMountDispatchActionCompoennt = () => {
        props.setinvokeDispatchComponent();
    }
    var handleConfirmationModalOkFunction = () => {
        switch(confirmationModalObj.ConfirmationSuccessFunctionName) {
            case "checkForWheelChairDispatch":
                checkForWheelChairDispatch();
                break;
            case "DeviceDispatch":
                DeviceDispatch();
                break;
            default:
                alert("No function assigned to confirmation dialog for ok/yes");
                break;
        }
    }
    const handleConfirmationModalOk = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        handleConfirmationModalOkFunction();
    }

    const handleConfirmationModalCancel = () => {
        setConfirmationModalObj((prevState) => ({...prevState, show:false}));
        UnMountDispatchActionCompoennt();
    }

    return(
        <>
        {showDispatchAlert?(
        <Modal centered show={showDispatchAlert}  animation={false} >
                                  <Modal.Header style={{height: "50px"}} closeButton>
                                    <Modal.Title>{DispatchAlert.alertTitle}</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body><b>{DispatchAlert.alertMsg}</b></Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={handleDispatchAlertModalClose}>
                                      Close
                                    </Button>
                                  </Modal.Footer>
                                </Modal>)
            : ""}
         <ConfirmationModal show={confirmationModalObj.show} Title={confirmationModalObj.title} Body={confirmationModalObj.body}
        onOk={handleConfirmationModalOk} onCancel={handleConfirmationModalCancel} btnCanceText={confirmationModalObj.btnCanceText}
        btnOkText={confirmationModalObj.btnOkText}  ShowCancelButton="true" />
        </>
    );
}

export default DispatchAction;